import React from 'react'

function InductionOutletINV() {
  return (
    <embed src="\pdfs\E1.1.9_IN-V_Adjustable_induction_outlet_04.2013_kr.pdf" width="100%" height="2100px" />
  )
}

export default InductionOutletINV